import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "../app/globals.css";
import { ArchitectureHealthDock } from "../app/architecture-health-dock";
import { RunyiEnterpriseRoot } from "../app/runyi-enterprise-root";
import {
  ThegMoviesHostMount,
  isThegMoviesPath,
} from "../app/theg-movies-host-mount";
import { startRunyiRuntimeUpdates } from "./runtime-update";

void startRunyiRuntimeUpdates();

const pathname =
  typeof window !== "undefined" ? window.location.pathname || "/" : "/";
const mountTheg = isThegMoviesPath(pathname);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {mountTheg ? <ThegMoviesHostMount /> : <RunyiEnterpriseRoot />}
    <ArchitectureHealthDock />
  </StrictMode>,
);
